import { render, staticRenderFns } from "./AdminApiKeys.vue?vue&type=template&id=4f96cce2&scoped=true&"
import script from "./AdminApiKeys.vue?vue&type=script&lang=ts&"
export * from "./AdminApiKeys.vue?vue&type=script&lang=ts&"
import style0 from "./AdminApiKeys.vue?vue&type=style&index=0&id=4f96cce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f96cce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f96cce2')) {
      api.createRecord('4f96cce2', component.options)
    } else {
      api.reload('4f96cce2', component.options)
    }
    module.hot.accept("./AdminApiKeys.vue?vue&type=template&id=4f96cce2&scoped=true&", function () {
      api.rerender('4f96cce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdminApiKeys.vue"
export default component.exports